// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2Oss2","checkboxCol":"Table_checkboxCol__c5dwp","emailCol":"Table_emailCol__1dfkG","actionCol":"Table_actionCol__1E3pX"};